<template>
  <div>
    <WarningMessage v-if="disconnectedMsgShown" :textMsg="MsgLostNetwork" />
  </div>
</template>
<script lang="ts" src="./lost-connection-warning.ts"></script>
